export const definitionKinds = ['event', 'assessment', 'measure', 'unit', 'rubric', 'scoring', 'validation', 'schedule', 'cohort', 'team', 'destination', 'survey'] as const;
export type DefinitionKind = typeof definitionKinds[number];
export interface Definition { id: string; kind: DefinitionKind; depends_on: string[]; spec: Record<string, unknown> }
export type ConfigurationState = 'draft' | 'review' | 'approved' | 'published' | 'retired';
export interface ConfigVersion {
  id: string; program_id: string; orgPath: string; name: string; state: ConfigurationState;
  record_version: number; definitions: Definition[]; effective_from: string; effective_until?: string;
  parent_id?: string; digest?: string; published_at?: string; created_by: string; updated_by?: string;
}
export interface ActiveConfigurations {
  tenantId: string; actorId: string; program: { id: string; orgPath: string }; as_of: string; items: ConfigVersion[];
}
export interface ValidationResult { valid: boolean; errors: { path: string; message: string }[] }
export type DraftInput = Pick<ConfigVersion, 'program_id' | 'name' | 'definitions' | 'effective_from'> & { effective_until?: string };
